var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotiCircle = function SvgNotiCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NotiCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#4980F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.137 5.863a1.239 1.239 0 0 1 0 1.752 4.336 4.336 0 0 1-.876 4.381l-1.314 1.313a2.477 2.477 0 0 0-.438 2.191L4.5 8.492a2.478 2.478 0 0 0 2.19-.438l1.314-1.315a4.337 4.337 0 0 1 4.381-.876 1.24 1.24 0 0 1 1.752 0ZM6.316 11.5l-.364.364a1.544 1.544 0 0 0 2.184 2.184l.364-.364",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NotiCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgNotiCircle;